export default __webpack_public_path__ + "static/media/beef-mobile@2x.d5427957.jpg";